import { createTheme } from '@mui/material/styles';
import { lightPalette, darkPalette } from './palette';
import typography from './typography';
import components from './components';

/**
 * Returns design tokens based on color mode.
 * @param {'light'|'dark'} mode
 */
const getDesignTokens = (mode) => ({
  palette: mode === 'light' ? lightPalette : darkPalette,
  typography,
  components,
});

/**
 * Theme configuration for the application.
 * Combines palette, typography, breakpoints, and component overrides.
 * @param {'light'|'dark'} mode
 */
const getTheme = (mode) => createTheme(getDesignTokens(mode));

export { getTheme };